import { Trans } from '@lingui/react/macro';
import { useMemo } from 'react';

import type { AdGroupActivityDataType } from '@/api/ad';
import { Button } from '@/components/buttons';
import { Badge } from '@/components/typography';
import { AD_GROUP_SCORE_MAX_LIMIT, AD_GROUP_SCORE_MIN_LIMIT } from '@/constants';

type Props = {
  selectedAdGroups: AdGroupActivityDataType[];
  onRemoveSelectedAdGroup: (adGroup: AdGroupActivityDataType) => void;
  onScoreAdGroups: (adGroups: string[]) => void;
};

const AdGroupTableActionContent = ({
  selectedAdGroups,
  onRemoveSelectedAdGroup,
  onScoreAdGroups,
}: Props) => {
  const selectedAdGroupIds = useMemo(
    () => selectedAdGroups.map((adGroup) => adGroup.adGroup.id),
    [selectedAdGroups],
  );

  const disableScore =
    selectedAdGroups.length < AD_GROUP_SCORE_MIN_LIMIT ||
    selectedAdGroups.length > AD_GROUP_SCORE_MAX_LIMIT;

  return (
    <div className="flex items-start gap-4">
      <Button disabled={disableScore} onClick={() => onScoreAdGroups(selectedAdGroupIds)}>
        <Trans>Score {disableScore ? '' : ` (${selectedAdGroups.length})`}</Trans>
      </Button>
      <div className="flex flex-wrap gap-1">
        {selectedAdGroups.map((adGroup) => (
          <Badge key={adGroup.adGroup.id} closable onClose={() => onRemoveSelectedAdGroup(adGroup)}>
            {adGroup.adGroup.name}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default AdGroupTableActionContent;
